import {createReducer} from 'redux-create-reducer';
import {Actions} from '../constants';
import * as Immutable from 'immutable';
import {MutationConstants} from '../action-creators/mutation-actions';

const hasEmptyAddOrRemove = (transform) => {
    const added= transform.get(MutationConstants.ADDED, Immutable.Map());
    return added.isEmpty()&&transform.get(MutationConstants.REMOVED, Immutable.Map()).isEmpty()
};
const hasAddOrRemove = (transform) => {
    const added= transform.get(MutationConstants.ADDED, MutationConstants.UNDEFINED);
    return added !== MutationConstants.UNDEFINED;
};
// empty is either {} or {added:[], removed:[]}
export const filterOutEmptyTransforms = (mutation) => {
    return mutation.filterNot(
        (transform, prop) => (hasAddOrRemove(transform) && hasEmptyAddOrRemove(transform)) || transform.isEmpty()
    )
};
export const filterOutEmptyMutations = (items) => {
    return items.filter((mutation, id) => !mutation.isEmpty());
};

// Removes transforms that would result in current value
export const neutralizeMutation = (item, currentMutation) => {
    // assume non empty mutation;
    const neutralized = currentMutation.map((transform, prop) => {
        const actualValue = item.get(prop);
        if ( transform.has(MutationConstants.SET) ) {
            if( transform.get(MutationConstants.SET) === actualValue) {
                return Immutable.Map();
            }
        } else {
            transform = transform.updateIn([MutationConstants.ADDED], (added) => added.subtract(actualValue));
            transform = transform.updateIn([MutationConstants.REMOVED], (removed) => removed.intersect(actualValue));
        }
        return transform;
    });
    return filterOutEmptyTransforms(neutralized)
};


export default createReducer(
    {},
    {
      [Actions.MUTATIONS_SAVE]:(state, action) => {
          // path is editorId, type
          const path = action.payload.path;
          // a map of {id1: {prop:{}, prop2:{}}, id2:{...}}
          const mutations = action.payload.mutations;
          if ( !state.hasIn(path) ) {
              state = state.setIn(path,  Immutable.Map())
          }
          return state.updateIn(path, (idMap) =>{
              const merged = idMap.mergeWith((prev, next, key) => {
                  console.log(key, prev,  next);
                  return Immutable.Iterable.isIterable(prev)?prev.merge(next):next;
              }, mutations);
              const withoutEmptyTransforms = merged.map(filterOutEmptyTransforms);
              const withoutEmptyMutations = filterOutEmptyMutations(withoutEmptyTransforms);
              return withoutEmptyMutations;
          });
      },
      [Actions.MUTATION_SAVE]:(state, action) => {
          // path is editorId, type, id
          const path = action.payload.path;

          // a map properties {prop:{}, prop2:{}}}
          const mutation = action.payload.mutation;
          if ( !state.hasIn(path) ) {
              state = state.setIn(path,  Immutable.Map())
          }
          const merged=  state.updateIn(path, (org) => filterOutEmptyTransforms(org.merge(mutation)));
          if(merged.getIn(path).isEmpty()) {
              return merged.deleteIn(path);
          } else return merged;
      },
        [Actions.MUTATIONS_NEUTRALIZE]:(state, action) => {
            const itemType = action.payload.itemType;
            const items = action.payload.items;
            // for all editors, find itemtype,
            // for all mutations in that type,
            // compare to actual items
            return state.map((itemTypes, editorId) => {
                return itemTypes.map((mutations, type) => {
                    if ( type !== itemType) {
                        return mutations;
                    } else {
                        return filterOutEmptyMutations(mutations.map((mutation, id) => {
                            const item = items.get(id,  MutationConstants.UNDEFINED);
                            if ( item ===MutationConstants.UNDEFINED) {
                                return Immutable.Map();
                            }
                            return neutralizeMutation(item, mutation);
                        }))
                    }
                })
            })
        }
    },
);



// WEBPACK FOOTER //
// ./src/model/reducers/mutation-reducer.js